var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tab-pane fade",
    class: {
      'show active': _vm.isActive
    },
    attrs: {
      "id": "nav-event-highlights",
      "role": "tabpanel",
      "aria-labelledby": "nav-event-highlights-tab"
    }
  }, [_c('div', {
    staticClass: "event-highlights"
  }, [_c('ul', {
    staticClass: "nav nav-pills highlights-tabs",
    attrs: {
      "id": "highlights-pills-tab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "id": "highlights-tab",
      "data-toggle": "pill",
      "href": "#highlights-pane",
      "role": "tab",
      "aria-controls": "highlights-pane",
      "aria-selected": "true"
    }
  }, [_vm._v(" Highlights (" + _vm._s(_vm.highlights.length) + ") ")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "purchased-tab",
      "data-toggle": "pill",
      "href": "#purchased-pane",
      "role": "tab",
      "aria-controls": "purchased-pane",
      "aria-selected": "false"
    }
  }, [_vm._v(" Purchased (" + _vm._s(_vm.purchased.length) + ") ")])])]), _c('div', {
    staticClass: "tab-content highlights-tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "highlights-pane",
      "role": "tabpanel",
      "aria-labelledby": "highlights-tab"
    }
  }, [_c('p', {
    staticClass: "highlights-note"
  }, [_vm._v(" Note: Each video can be downloaded within 30 days of the activity upload date. Once purchased and downloaded, they remain in your library for 30 days from the purchase date. ")]), _vm.highlights.length ? _c('div', {
    staticClass: "row"
  }, _vm._l(_vm.highlights, function (video, i) {
    return _c('div', {
      key: i,
      staticClass: "col-12 col-sm-6 col-md-4"
    }, [_c('highlight-card', {
      attrs: {
        "video": video
      },
      on: {
        "play": _vm.openPlayer,
        "download": _vm.confirmDownload
      }
    })], 1);
  }), 0) : _c('p', {
    staticClass: "empty-state"
  }, [_vm._v("No highlights available.")]), _vm.highlightsHasMore ? _c('div', {
    staticClass: "hl-load-more"
  }, [_c('button', {
    staticClass: "hl-btn hl-btn--cancel",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoadingMoreHighlights
    },
    on: {
      "click": _vm.loadMoreHighlights
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.isLoadingMoreHighlights ? "Loading…" : "Load More"))])])]) : _vm._e()]), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "purchased-pane",
      "role": "tabpanel",
      "aria-labelledby": "purchased-tab"
    }
  }, [_c('p', {
    staticClass: "highlights-note"
  }, [_vm._v(" Note: Each purchased video remains in your library for 30 days from the purchase date. ")]), _vm.purchased.length ? _c('div', {
    staticClass: "row"
  }, _vm._l(_vm.purchased, function (video, i) {
    return _c('div', {
      key: i,
      staticClass: "col-12 col-sm-6 col-md-4"
    }, [_c('highlight-card', {
      attrs: {
        "video": video,
        "purchased": ""
      },
      on: {
        "play": _vm.openPlayer,
        "download": _vm.confirmRedownload,
        "delete": _vm.confirmDelete
      }
    })], 1);
  }), 0) : _c('p', {
    staticClass: "empty-state"
  }, [_vm._v("No purchased videos.")]), _vm.purchasedHasMore ? _c('div', {
    staticClass: "hl-load-more"
  }, [_c('button', {
    staticClass: "hl-btn hl-btn--cancel",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoadingMorePurchased
    },
    on: {
      "click": _vm.loadMorePurchased
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.isLoadingMorePurchased ? "Loading…" : "Load More"))])])]) : _vm._e()])]), _vm.activeVideo ? _c('highlight-video-player', {
    attrs: {
      "video": _vm.activeVideo
    },
    on: {
      "close": function ($event) {
        _vm.activeVideo = null;
      },
      "download": _vm.confirmDownload
    }
  }) : _vm._e(), _vm.confirmVideo ? _c('highlight-dialog', {
    attrs: {
      "title": "Download Video"
    },
    on: {
      "close": function ($event) {
        _vm.confirmVideo = null;
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c('button', {
          staticClass: "hl-btn hl-btn--cancel",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function ($event) {
              _vm.confirmVideo = null;
            }
          }
        }, [_c('span', [_vm._v("Cancel")])]), _vm.canAfford ? _c('button', {
          staticClass: "hl-btn hl-btn--download",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.doDownload
          }
        }, [_c('span', [_vm._v("Download")])]) : _c('button', {
          staticClass: "hl-btn hl-btn--buygems",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.buyGems
          }
        }, [_c('span', [_vm._v("Buy Gems")])])];
      },
      proxy: true
    }], null, false, 317242100)
  }, [_c('p', {
    staticClass: "hl-confirm-text"
  }, [_vm._v(" Downloading this video will cost " + _vm._s(_vm.confirmVideo.points) + " Gems."), _c('br'), _vm._v(" Do you want to continue? ")]), _c('div', {
    staticClass: "hl-confirm-box"
  }, [_c('div', {
    staticClass: "hl-confirm-cost"
  }, [_c('img', {
    attrs: {
      "src": "/assets/event-highlights/gems.svg",
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.confirmVideo.points))])]), _vm.canAfford ? _c('div', {
    staticClass: "hl-confirm-balance"
  }, [_vm._v(" Gems Balance: " + _vm._s(_vm.gems) + " ")]) : _c('div', {
    staticClass: "hl-confirm-balance is-error"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-circle"
  }), _vm._v(" Insufficient Gems Balance: " + _vm._s(_vm.gems) + " ")])])]) : _vm._e(), _vm.redownloadVideo ? _c('highlight-dialog', {
    attrs: {
      "title": "Download Video"
    },
    on: {
      "close": function ($event) {
        _vm.redownloadVideo = null;
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c('button', {
          staticClass: "hl-btn hl-btn--cancel",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function ($event) {
              _vm.redownloadVideo = null;
            }
          }
        }, [_c('span', [_vm._v("Cancel")])]), _c('button', {
          staticClass: "hl-btn hl-btn--download",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.doRedownload
          }
        }, [_c('span', [_vm._v("Download")])])];
      },
      proxy: true
    }], null, false, 3613898725)
  }, [_c('p', {
    staticClass: "hl-confirm-text"
  }, [_vm._v(" Are you sure you want to download this video ")])]) : _vm._e(), _vm.deleteVideo ? _c('highlight-dialog', {
    attrs: {
      "title": "Delete Video"
    },
    on: {
      "close": function ($event) {
        _vm.deleteVideo = null;
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c('button', {
          staticClass: "hl-btn hl-btn--cancel",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function ($event) {
              _vm.deleteVideo = null;
            }
          }
        }, [_c('span', [_vm._v("Cancel")])]), _c('button', {
          staticClass: "hl-btn hl-btn--danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.doDelete
          }
        }, [_c('span', [_vm._v("Delete")])])];
      },
      proxy: true
    }], null, false, 2002342247)
  }, [_c('p', {
    staticClass: "hl-confirm-text"
  }, [_vm._v(" Are you sure you want to delete this video ")])]) : _vm._e(), _vm.downloadingVideo ? _c('highlight-download-dialog', {
    attrs: {
      "video": _vm.downloadingVideo,
      "progress": _vm.downloadProgress,
      "downloaded-bytes": _vm.downloadedBytes,
      "total-bytes": _vm.totalBytes,
      "state": _vm.downloadDialogState
    },
    on: {
      "close": _vm.closeDownloading
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }